import React from 'react';
import CharacterSection from '../shared/CharacterSection';
import About from './About';
import Schedule from './Schedule';
import Tickets from './Tickets';
import FeaturedBaterias from './FeaturedBaterias';
import Workshops from './Workshops';
import MerchandiseSection from './MerchandiseSection';
import SimpleImageGallery from './SimpleImageGallery';

const ContentSections = () => {
  return (
    <>
      {/* About Section */}
      <div id="about">
        <CharacterSection
          title="About the Encontro"
          imageUrl="/assets/images/characters/cockatoo.png"
          backgroundColor="bg-white"
        >
          <About/>
        </CharacterSection>
      </div>

      {/* Schedule Section */}
      <div id="schedule">
        <CharacterSection
          title="Event Schedule"
          imageUrl="/assets/images/characters/schedule-guy.png"
          imagePosition="left"
          backgroundColor="bg-gray-50"
        >
          <Schedule/>
        </CharacterSection>
      </div>

      {/* Workshops Section */}
      <div id="workshops">
        <CharacterSection
          title="Workshops"
          imageUrl="/assets/images/characters/dancer.png"
          backgroundColor="bg-white"
        >
        <p className="text-lg mb-6">
          <Workshops/>
        </p>        
        </CharacterSection>
      </div>

      {/* Tickets Section */}
      <div id="tickets">
        <CharacterSection
          title="SOLD OUT!! Showcase Tickets"
          imageUrl="/assets/images/characters/bearded-drummer.png"
          imagePosition="left"
          backgroundColor="bg-gray-50"
        >
          <Tickets />
        </CharacterSection>
      </div>
      <div id="featured-baterias">
        <CharacterSection
          title="Featured baterias"
          imageUrl="/assets/images/characters/drummer-afro.png"
          backgroundColor="bg-white"
        >
        <FeaturedBaterias/>
      </CharacterSection>  
      </div>
      {/* Merch Section */}
      <div id="merch">
        <CharacterSection
          title="Merch"
          imageUrl="/assets/images/characters/hat-guy.png"
          imagePosition="left"
          backgroundColor="bg-gray-50"
        >
          <MerchandiseSection />
        </CharacterSection>
      </div> 
      <div id="samba-memories">
        <CharacterSection
          imageUrl="/assets/images/characters/cockatoo.png"
          title="Samba Memories"
          backgroundColor="bg-white"
        >
        <SimpleImageGallery 
          folderId="1qZf2vuUrraZBHYRnLnKbqfi3u_LW5mEs" // Replace with your actual folder ID
        />
        </CharacterSection>
      </div>
    </>
  );
};

export default ContentSections;